<template>
  <!-- 在线转账 -->
  <section class="container">
    <Header></Header>
    <div class="wrapper">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt="" />
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>专家介绍</BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="innerM">
        <div class="title">专家介绍</div>

        <el-row
         
          :gutter="20"
          v-for="(item, index) in professorList"
          :key="index"
        >
          <el-col :span="8">
            <!-- <el-avatar
              shape="square"
              :size="120"
              fit="contain"
              :src="item.picture"
            ></el-avatar> -->
            <img style="height:250px;width:170px" :src="item.picture"/>
          </el-col>
          <el-col :span="12">
            <div class="inner-wrapper" v-html="item.intro"></div>
          </el-col>
        </el-row>

        <!-- 分页 -->
        <div class="pageM">
         
          <el-pagination
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </section>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "Transfer",
  data() {
    return {
     
      totalCount: 0, // 总页数
      currPage: 1, // 当前页数
      pageSize: 3, // 每页条数
      professorList: [],
    };
  },
  mounted() {
    // this.getInstance();
    this.setTab();
    this.getProfessorList();
  },
  methods: {
    // getInstance() {
    //   var that = this;
    //   this.$http({
    //     url: that.webhost + "guide/getContent/1",
    //     method: "GET",
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       that.content = data.data;
    //     }
    //   });
    // },
 
    // 当前页变动时候触发的事件
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currPage = val;
      this.getProfessorList();
    },
    // 专家介绍分页数据
    getProfessorList() {
      var that = this;
      var data = {
        page: that.currPage,
        size: that.pageSize,
      };
      this.$http({
        url: that.webhost + "expert/list",
        method: "POST",
        data: data,
      }).then(({ data }) => {
        console.log(data);
        if (data && data.code === 0) {
          that.professorList = data.data.list;
          that.totalCount = data.data.totalCount;
          that.currPage = data.data.currPage;
          console.log(that.total);
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
  },
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped>
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}
.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
  margin-bottom: 15px;
}
.locationM {
  height: 50px;
  line-height: 50px;
}
.locationM .ivu-breadcrumb {
  font-size: 15px;
  color: #000;
}
.locationM img {
  width: 23px;
  height: 22px;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.inner-wrapper {
  padding: 0px 10px 0px 15px;
  font-size: 20px;
  text-align: left;
  text-indent: 2em;
}

.el-row {
  margin-bottom: 20px;
  width: 100%;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/views/Professor.vue